const LogoInteracDeposit: React.FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 28 28"
    width="28"
    height="28"
    className="option__nuvei-logo"
  >
    <title>image_2025_03_07T17_55_37_764Z</title>
    <defs>
      <image
        width="28"
        height="28"
        id="img1"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAAXNSR0IB2cksfwAAAftQTFRFAAAA/7kq/7kq/7kq/7kq/7kq/7kq/7kq/7kq/7kq/7kq/7kq/7kq9bIqqX4omnQo6aoq+7YqypUpmXMosoQp+rYqfV8oaFEnW0gnhmYo/Lcq4aUppnwoqX4pl3IoWUcng2QoSTwnvo0pMy0m3aEp56kq46Yp97Mq5acqtIUpiGco5qgqgmMoYk4nrH8psYQpMiwmZE8nrYEpq38pnncoRTkmlXAoLSkm8a8q9LEqzJYpgWIo764q4aQp4aQqZlAnOjImd1woclgnlnEoTD4noXkoPjUmxpIpw5ApV0YnaFInQzgnp30oLyomyZQpmHIob1cohWUocVgoyJMpfmAoVEMnOzMml3EoZ1Ena1MnvYwph2coaVInTT8nUEEn6KkqcVgnwY4pPTQmvIspclknVEQn154pnXYoPjQm2Z8pkm4olHAod1soPDMmkG0oqH0oUUIn8K8qY04ndlsn+LQq46Yq9LIqfF8olG8odlsok28ohGUoalMn9rMq8rAq8K4qnnYoqn8ouYkpv44ph2Yo7q0qt4gp5KYp/bgqiWgof2Eo4KQq7a0qx5IpXkon/bcqpnwpYEwnSz0nuIgpeF0oNC0meFwoXksnT0EnrYEokW0oSDwn/7kqs4Up/7kq/7kqy5YpXUon/7kq/7kq/7kq3KEp/7kq/7kq/7kqv+mgLAAAAKl0Uk5TABaT7P+SFeHglJDu6v//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////5f/jhP//fw/S/84Ng3qJ5EgAAAFHSURBVHicY2RgBAIGTPCfifEXIyPbXyxSIMDyj5HzNw45BgY2Ru6fOCU5GFlwyjEwUF+SE+jBL1gkeRmh4DVCUuwViBRnRIB7jCzKjHdAoqqM/5gZUcEpRhZ+jZMMFiD2eSM0yS2MLL5wzkcBRsZP/EAd5kDOXhfGeSBJUUbGz3yMjO+EGR9cASrdKaPDOD+JkbGPASx56nLxdy7Gt7sjGY9czQC6UqwV5k+g5Ia3xd+FjlkzzjW9yOTfhxwIvoyGs581/GFlZKxtqUEPoVbGFX+vtjNWYA2+zvaqjT4spdjDtofx7xOFBV/vYpXsZ/z15Gjc5j1YJbXTGRnnMyRlY5WcxvhnAQMuyUoGKaDk70vYJOdkMAgrMDCkpWPKzWKcn8owZwJ7Vv4XTMl5jIsZExgsMs9PwJRbBMwJi1m/ZGCxbxYLayQABhFYcOXhcXoAAAAASUVORK5CYII="
      />
    </defs>
    <style></style>
    <use id="Background" href="#img1" x="0" y="0" />
  </svg>
);

export default LogoInteracDeposit;
